import * as React from 'react';

import './style.scss';

import {A} from 'components/atoms/LinksAndButtons/A';
import {P} from 'components/atoms/Text/P';
import {getCoOwningLabel, getFormattedMessage} from "features/services/utils/language-helper";
import { getCurrentLocale } from 'features/services/utils/env-helper';
import { Margin, LOCALE, HeadlineLevel} from 'features/ui/enums';
import { FormattedMessage } from 'react-intl';
import {Headline} from '@atoms/Text/Headline';

interface Props {
    link?: string;
}

export const CoOwningModal: React.FunctionComponent<Props> = ({link}) => {
    if(getCurrentLocale() === LOCALE.FI || getCurrentLocale() === LOCALE.NO) return (
        <div className='coowning-modal'>
            <Headline level={HeadlineLevel.H2} center margin={Margin.L}>
                <FormattedMessage id="jm.components.CoOwningModal.header" />
            </Headline>
            <P>
                <strong><FormattedMessage id="jm.components.CoOwningModal.priceHeader" /></strong><br />
                <FormattedMessage id="jm.components.CoOwningModal.priceText" />
            </P>
            <P>
                <strong><FormattedMessage id="jm.components.CoOwningModal.sharedCostHeader" /></strong><br/>
                <FormattedMessage id="jm.components.CoOwningModal.sharedCostText" />
            </P>
            <P>
                <FormattedMessage id="jm.components.CoOwningModal.questions" />
                {link && <> <FormattedMessage id="jm.components.CoOwningModal.or" /> <A href={link} title={getFormattedMessage('jm.components.CoOwningModal.linkText')} ><FormattedMessage id="jm.components.CoOwningModal.linkText" /></A></>}.
            </P>
        </div>
    );

    return (
        <div className='coowning-modal'>
            <Headline level={HeadlineLevel.H2} center margin={Margin.L}>Pris vid {getCoOwningLabel()}</Headline>
            <P>
                <strong><FormattedMessage id="jm.components.CoOwningModal.priceHeader" /></strong><br />
                {getCoOwningLabel()} är en flexibel finansieringsmodell där du till en början finansierar minst 50 procent av bostaden och samäger resterande del med JM. Du kan därefter årligen öka din ägarandel stegvis.
            </P>
            <P>
                <strong><FormattedMessage id="jm.components.CoOwningModal.sharedCostHeader" /></strong><br/>
                Vid {getCoOwningLabel()} tillkommer en samägaravgift. I takt med att du köper till fler andelar av bostaden minskar samägaravgiften proportionerligt och upphör när du köpt samtliga andelar.
            </P>
            <P>För frågor om {getCoOwningLabel()}, kontakta ansvarig mäklare{link && <> eller <A href={link} title={'läs mer om ' + getCoOwningLabel() + ' här'} >läs mer om {getCoOwningLabel()} här</A></>}.</P>
        </div>
    );
}
